/* @zyf2e/monitor-core version ' + 2.1.55 */
import { BREADCRUMBCATEGORYS, BREADCRUMBTYPES, ERRORTYPES, EVENTTYPES, SDK_VERSION, SDK_NAME, globalVar } from '@zyf2e/monitor-shared';
import { _support, slientConsoleScope, getTimestamp, logger, validateOption, toStringValidateOption, generateUUID, setSilentFlag, variableTypeDetection, isWxMiniEnv, getAppId, Queue, isBrowserEnv, isEmpty, Severity, isError, extractErrorStack, unknownToString, getCurrentRoute, getLocationHref, fromHttpStatus, SpanStatus, interceptStr, getFlag, setFlag, nativeTryCatch, getFunctionName } from '@zyf2e/monitor-utils';
import { isReportDataType, EMethods } from '@zyf2e/monitor-types';

var Breadcrumb = (function () {
    function Breadcrumb() {
        this.maxBreadcrumbs = 10;
        this.beforePushBreadcrumb = null;
        this.stack = [];
    }
    Breadcrumb.prototype.push = function (data) {
        var _this = this;
        if (typeof this.beforePushBreadcrumb === 'function') {
            var result_1 = null;
            var beforePushBreadcrumb_1 = this.beforePushBreadcrumb;
            slientConsoleScope(function () {
                result_1 = beforePushBreadcrumb_1(_this, data);
            });
            if (!result_1)
                return;
            this.immediatePush(result_1);
            return;
        }
        this.immediatePush(data);
    };
    Breadcrumb.prototype.immediatePush = function (data) {
        data.time || (data.time = getTimestamp());
        if (this.stack.length >= this.maxBreadcrumbs) {
            this.shift();
        }
        this.stack.push(data);
        this.stack.sort(function (a, b) { return a.time - b.time; });
        logger.log(this.stack);
    };
    Breadcrumb.prototype.shift = function () {
        return this.stack.shift() !== undefined;
    };
    Breadcrumb.prototype.clear = function () {
        this.stack = [];
    };
    Breadcrumb.prototype.getStack = function () {
        return this.stack;
    };
    Breadcrumb.prototype.getCategory = function (type) {
        switch (type) {
            case BREADCRUMBTYPES.XHR:
            case BREADCRUMBTYPES.FETCH:
                return BREADCRUMBCATEGORYS.HTTP;
            case BREADCRUMBTYPES.CLICK:
            case BREADCRUMBTYPES.ROUTE:
            case BREADCRUMBTYPES.TAP:
            case BREADCRUMBTYPES.TOUCHMOVE:
                return BREADCRUMBCATEGORYS.USER;
            case BREADCRUMBTYPES.CUSTOMER:
            case BREADCRUMBTYPES.CONSOLE:
                return BREADCRUMBCATEGORYS.DEBUG;
            case BREADCRUMBTYPES.APP_ON_LAUNCH:
            case BREADCRUMBTYPES.APP_ON_SHOW:
            case BREADCRUMBTYPES.APP_ON_HIDE:
            case BREADCRUMBTYPES.PAGE_ON_SHOW:
            case BREADCRUMBTYPES.PAGE_ON_HIDE:
            case BREADCRUMBTYPES.PAGE_ON_SHARE_APP_MESSAGE:
            case BREADCRUMBTYPES.PAGE_ON_SHARE_TIMELINE:
            case BREADCRUMBTYPES.PAGE_ON_TAB_ITEM_TAP:
                return BREADCRUMBCATEGORYS.LIFECYCLE;
            case BREADCRUMBTYPES.UNHANDLEDREJECTION:
            case BREADCRUMBTYPES.CODE_ERROR:
            case BREADCRUMBTYPES.RESOURCE:
            case BREADCRUMBTYPES.VUE:
            case BREADCRUMBTYPES.REACT:
            default:
                return BREADCRUMBCATEGORYS.EXCEPTION;
        }
    };
    Breadcrumb.prototype.bindOptions = function (options) {
        if (options === void 0) { options = {}; }
        var maxBreadcrumbs = options.maxBreadcrumbs, beforePushBreadcrumb = options.beforePushBreadcrumb;
        validateOption(maxBreadcrumbs, 'maxBreadcrumbs', 'number') && (this.maxBreadcrumbs = maxBreadcrumbs);
        validateOption(beforePushBreadcrumb, 'beforePushBreadcrumb', 'function') && (this.beforePushBreadcrumb = beforePushBreadcrumb);
    };
    return Breadcrumb;
}());
var breadcrumb = _support.breadcrumb || (_support.breadcrumb = new Breadcrumb());

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var Options = (function () {
    function Options() {
        this.beforeAppAjaxSend = function () { };
        this.traceIdFieldName = 'Trace-Id';
        this.throttleDelayTime = 0;
        this.maxDuplicateCount = 2;
        this.appOnLaunch = function () { };
        this.appOnShow = function () { };
        this.onPageNotFound = function () { };
        this.appOnHide = function () { };
        this.pageOnUnload = function () { };
        this.pageOnShow = function () { };
        this.pageOnHide = function () { };
        this.onShareAppMessage = function () { };
        this.onShareTimeline = function () { };
        this.onTabItemTap = function () { };
        this.triggerWxEvent = function () { };
        this.enableTraceId = false;
    }
    Options.prototype.bindOptions = function (options) {
        if (options === void 0) { options = {}; }
        var beforeAppAjaxSend = options.beforeAppAjaxSend, enableTraceId = options.enableTraceId, filterXhrUrlRegExp = options.filterXhrUrlRegExp, traceIdFieldName = options.traceIdFieldName, throttleDelayTime = options.throttleDelayTime, includeHttpUrlTraceIdRegExp = options.includeHttpUrlTraceIdRegExp, appOnLaunch = options.appOnLaunch, appOnShow = options.appOnShow, appOnHide = options.appOnHide, pageOnUnload = options.pageOnUnload, pageOnShow = options.pageOnShow, pageOnHide = options.pageOnHide, onPageNotFound = options.onPageNotFound, onShareAppMessage = options.onShareAppMessage, onShareTimeline = options.onShareTimeline, onTabItemTap = options.onTabItemTap, wxNavigateToMiniProgram = options.wxNavigateToMiniProgram, triggerWxEvent = options.triggerWxEvent, maxDuplicateCount = options.maxDuplicateCount, onRouteChange = options.onRouteChange;
        validateOption(beforeAppAjaxSend, 'beforeAppAjaxSend', 'function') && (this.beforeAppAjaxSend = beforeAppAjaxSend);
        validateOption(appOnLaunch, 'appOnLaunch', 'function') && (this.appOnLaunch = appOnLaunch);
        validateOption(appOnShow, 'appOnShow', 'function') && (this.appOnShow = appOnShow);
        validateOption(appOnHide, 'appOnHide', 'function') && (this.appOnHide = appOnHide);
        validateOption(pageOnUnload, 'pageOnUnload', 'function') && (this.pageOnUnload = pageOnUnload);
        validateOption(pageOnShow, 'pageOnShow', 'function') && (this.pageOnShow = pageOnShow);
        validateOption(pageOnHide, 'pageOnHide', 'function') && (this.pageOnHide = pageOnHide);
        validateOption(onPageNotFound, 'onPageNotFound', 'function') && (this.onPageNotFound = onPageNotFound);
        validateOption(onShareAppMessage, 'onShareAppMessage', 'function') && (this.onShareAppMessage = onShareAppMessage);
        validateOption(onShareTimeline, 'onShareTimeline', 'function') && (this.onShareTimeline = onShareTimeline);
        validateOption(onTabItemTap, 'onTabItemTap', 'function') && (this.onTabItemTap = onTabItemTap);
        validateOption(wxNavigateToMiniProgram, 'wxNavigateToMiniProgram', 'function') &&
            (this.wxNavigateToMiniProgram = wxNavigateToMiniProgram);
        validateOption(triggerWxEvent, 'triggerWxEvent', 'function') && (this.triggerWxEvent = triggerWxEvent);
        validateOption(onRouteChange, 'onRouteChange', 'function') && (this.onRouteChange = onRouteChange);
        validateOption(enableTraceId, 'enableTraceId', 'boolean') && (this.enableTraceId = enableTraceId);
        validateOption(traceIdFieldName, 'traceIdFieldName', 'string') && (this.traceIdFieldName = traceIdFieldName);
        validateOption(throttleDelayTime, 'throttleDelayTime', 'number') && (this.throttleDelayTime = throttleDelayTime);
        validateOption(maxDuplicateCount, 'maxDuplicateCount', 'number') && (this.maxDuplicateCount = maxDuplicateCount);
        toStringValidateOption(filterXhrUrlRegExp, 'filterXhrUrlRegExp', '[object RegExp]') && (this.filterXhrUrlRegExp = filterXhrUrlRegExp);
        toStringValidateOption(includeHttpUrlTraceIdRegExp, 'includeHttpUrlTraceIdRegExp', '[object RegExp]') &&
            (this.includeHttpUrlTraceIdRegExp = includeHttpUrlTraceIdRegExp);
    };
    return Options;
}());
var options = _support.options || (_support.options = new Options());
function setTraceId(httpUrl, callback) {
    var includeHttpUrlTraceIdRegExp = options.includeHttpUrlTraceIdRegExp, enableTraceId = options.enableTraceId;
    if (enableTraceId && includeHttpUrlTraceIdRegExp && includeHttpUrlTraceIdRegExp.test(httpUrl)) {
        var traceId = generateUUID();
        callback(options.traceIdFieldName, traceId);
    }
}
function initOptions(paramOptions) {
    if (paramOptions === void 0) { paramOptions = {}; }
    setSilentFlag(paramOptions);
    breadcrumb.bindOptions(paramOptions);
    logger.bindOptions(paramOptions.debug);
    transportData.bindOptions(paramOptions);
    options.bindOptions(paramOptions);
}

var allErrorNumber = {};
function createErrorId(data, apikey) {
    var id;
    switch (data.type) {
        case ERRORTYPES.FETCH_ERROR:
            id = data.type + data.request.method + data.response.status + getRealPath(data.request.url) + apikey;
            break;
        case ERRORTYPES.JAVASCRIPT_ERROR:
        case ERRORTYPES.VUE_ERROR:
        case ERRORTYPES.REACT_ERROR:
            id = data.type + data.name + data.message + apikey;
            break;
        case ERRORTYPES.LOG_ERROR:
            id = data.customTag + data.type + data.name + apikey;
            break;
        case ERRORTYPES.PROMISE_ERROR:
            id = generatePromiseErrorId(data, apikey);
            break;
        default:
            id = data.type + data.message + apikey;
            break;
    }
    id = hashCode(id);
    if (allErrorNumber[id] >= options.maxDuplicateCount) {
        return null;
    }
    if (typeof allErrorNumber[id] === 'number') {
        allErrorNumber[id]++;
    }
    else {
        allErrorNumber[id] = 1;
    }
    return id;
}
function generatePromiseErrorId(data, apikey) {
    var locationUrl = getRealPath(data.url);
    if (data.name === EVENTTYPES.UNHANDLEDREJECTION) {
        return data.type + objectOrder(data.message) + apikey;
    }
    return data.type + data.name + objectOrder(data.message) + locationUrl;
}
function objectOrder(reason) {
    var sortFn = function (obj) {
        return Object.keys(obj)
            .sort()
            .reduce(function (total, key) {
            if (variableTypeDetection.isObject(obj[key])) {
                total[key] = sortFn(obj[key]);
            }
            else {
                total[key] = obj[key];
            }
            return total;
        }, {});
    };
    try {
        if (/\{.*\}/.test(reason)) {
            var obj = JSON.parse(reason);
            obj = sortFn(obj);
            return JSON.stringify(obj);
        }
    }
    catch (error) {
        return reason;
    }
}
function getRealPath(url) {
    return url.replace(/[\?#].*$/, '').replace(/\/\d+([\/]*$)/, '{param}$1');
}
function getFlutterRealOrigin(url) {
    return removeHashPath(getFlutterRealPath(url));
}
function getFlutterRealPath(url) {
    return url.replace(/(\S+)(\/Documents\/)(\S*)/, "$3");
}
function getRealPageOrigin(url) {
    var fileStartReg = /^file:\/\//;
    if (fileStartReg.test(url)) {
        return getFlutterRealOrigin(url);
    }
    if (isWxMiniEnv) {
        return getAppId();
    }
    return getRealPath(removeHashPath(url).replace(/(\S*)(\/\/)(\S+)/, '$3'));
}
function removeHashPath(url) {
    return url.replace(/(\S+)(\/#\/)(\S*)/, "$1");
}
function hashCode(str) {
    var hash = 0;
    if (str.length == 0)
        return hash;
    for (var i = 0; i < str.length; i++) {
        var char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
    }
    return hash;
}

function safeStringify(obj) {
    var cache = [];
    try {
        return JSON.stringify(obj, function (key, value) {
            if (typeof value === 'object' && value !== null) {
                if (cache.indexOf(value) !== -1) {
                    return;
                }
                cache.push(value);
            }
            return value;
        });
    }
    catch (e) {
        return 'JSON.stringify(obj) error';
    }
}
var TransportData = (function () {
    function TransportData() {
        this.beforeDataReport = null;
        this.backTrackerId = null;
        this.configReportXhr = null;
        this.configReportUrl = null;
        this.configReportWxRequest = null;
        this.useImgUpload = false;
        this.apikey = '';
        this.trackKey = '';
        this.errorDsn = '';
        this.trackDsn = '';
        this.queue = new Queue();
    }
    TransportData.prototype.imgRequest = function (data, url) {
        var requestFun = function () {
            var img = new Image();
            var spliceStr = url.indexOf('?') === -1 ? '?' : '&';
            img.src = "" + url + spliceStr + "data=" + encodeURIComponent(JSON.stringify(data));
            img = null;
        };
        this.queue.addFn(requestFun);
    };
    TransportData.prototype.getRecord = function () {
        var recordData = _support.record;
        if (recordData && variableTypeDetection.isArray(recordData) && recordData.length > 2) {
            return recordData;
        }
        return [];
    };
    TransportData.prototype.getDeviceInfo = function () {
        return _support.deviceInfo || {};
    };
    TransportData.prototype.beforePost = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var errorId, transportData;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (isReportDataType(data)) {
                            errorId = createErrorId(data, this.apikey);
                            if (!errorId)
                                return [2, false];
                            data.errorId = errorId;
                        }
                        transportData = this.getTransportData(data);
                        if (!(typeof this.beforeDataReport === 'function')) return [3, 2];
                        return [4, this.beforeDataReport(transportData)];
                    case 1:
                        transportData = _a.sent();
                        if (!transportData)
                            return [2, false];
                        _a.label = 2;
                    case 2: return [2, transportData];
                }
            });
        });
    };
    TransportData.prototype.xhrPost = function (data, url) {
        return __awaiter(this, void 0, void 0, function () {
            var requestFun, idleRequest;
            var _this = this;
            return __generator(this, function (_a) {
                requestFun = function () {
                    var xhr = new XMLHttpRequest();
                    xhr.open(EMethods.Post, url);
                    xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
                    xhr.withCredentials = true;
                    if (typeof _this.configReportXhr === 'function') {
                        _this.configReportXhr(xhr, data);
                    }
                    xhr.send(safeStringify(data));
                };
                idleRequest = function () {
                    if ('requestIdleCallback' in window) {
                        window.requestIdleCallback(requestFun, { timeout: 1000 });
                    }
                    else {
                        requestFun();
                    }
                };
                this.queue.addFn(idleRequest);
                return [2];
            });
        });
    };
    TransportData.prototype.wxPost = function (data, url) {
        return __awaiter(this, void 0, void 0, function () {
            var requestFun;
            var _this = this;
            return __generator(this, function (_a) {
                requestFun = function () {
                    var requestOptions = { method: 'POST' };
                    if (typeof _this.configReportWxRequest === 'function') {
                        var params = _this.configReportWxRequest(data);
                        requestOptions = __assign(__assign({}, requestOptions), params);
                    }
                    requestOptions = __assign(__assign({}, requestOptions), { data: safeStringify(data), url: url });
                    wx.request(requestOptions);
                };
                this.queue.addFn(requestFun);
                return [2];
            });
        });
    };
    TransportData.prototype.getAuthInfo = function () {
        var trackerId = this.getTrackerId();
        var result = {
            trackerId: String(trackerId),
            sdkVersion: SDK_VERSION,
            sdkName: SDK_NAME
        };
        this.apikey && (result.apikey = this.apikey);
        this.trackKey && (result.trackKey = this.trackKey);
        return result;
    };
    TransportData.prototype.getApikey = function () {
        return this.apikey;
    };
    TransportData.prototype.getTrackKey = function () {
        return this.trackKey;
    };
    TransportData.prototype.getTrackerId = function () {
        if (typeof this.backTrackerId === 'function') {
            var trackerId = this.backTrackerId();
            if (typeof trackerId === 'string' || typeof trackerId === 'number') {
                return trackerId;
            }
            else {
                logger.error("trackerId:" + trackerId + " \u671F\u671B string \u6216 number \u7C7B\u578B\uFF0C\u4F46\u662F\u4F20\u5165 " + typeof trackerId);
            }
        }
        return '';
    };
    TransportData.prototype.getTransportData = function (data) {
        return {
            authInfo: this.getAuthInfo(),
            breadcrumb: breadcrumb.getStack(),
            data: data,
            record: this.getRecord(),
            deviceInfo: this.getDeviceInfo()
        };
    };
    TransportData.prototype.isSdkTransportUrl = function (targetUrl) {
        var isSdkDsn = false;
        if (this.errorDsn && targetUrl.indexOf(this.errorDsn) !== -1) {
            isSdkDsn = true;
        }
        if (this.trackDsn && targetUrl.indexOf(this.trackDsn) !== -1) {
            isSdkDsn = true;
        }
        return isSdkDsn;
    };
    TransportData.prototype.bindOptions = function (options) {
        if (options === void 0) { options = {}; }
        var dsn = options.dsn, beforeDataReport = options.beforeDataReport, apikey = options.apikey, configReportXhr = options.configReportXhr, backTrackerId = options.backTrackerId, trackDsn = options.trackDsn, trackKey = options.trackKey, configReportUrl = options.configReportUrl, useImgUpload = options.useImgUpload, configReportWxRequest = options.configReportWxRequest;
        validateOption(apikey, 'apikey', 'string') && (this.apikey = apikey);
        validateOption(trackKey, 'trackKey', 'string') && (this.trackKey = trackKey);
        validateOption(dsn, 'dsn', 'string') && (this.errorDsn = dsn);
        validateOption(trackDsn, 'trackDsn', 'string') && (this.trackDsn = trackDsn);
        validateOption(useImgUpload, 'useImgUpload', 'boolean') && (this.useImgUpload = useImgUpload);
        validateOption(beforeDataReport, 'beforeDataReport', 'function') && (this.beforeDataReport = beforeDataReport);
        validateOption(configReportXhr, 'configReportXhr', 'function') && (this.configReportXhr = configReportXhr);
        validateOption(backTrackerId, 'backTrackerId', 'function') && (this.backTrackerId = backTrackerId);
        validateOption(configReportUrl, 'configReportUrl', 'function') && (this.configReportUrl = configReportUrl);
        validateOption(configReportWxRequest, 'configReportWxRequest', 'function') && (this.configReportWxRequest = configReportWxRequest);
    };
    TransportData.prototype.send = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var dsn, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        dsn = '';
                        if (isReportDataType(data)) {
                            dsn = this.errorDsn;
                            if (isEmpty(dsn)) {
                                logger.error('dsn为空，没有传入监控错误上报的dsn地址，请在init中传入');
                                return [2];
                            }
                        }
                        else {
                            dsn = this.trackDsn;
                            if (isEmpty(dsn)) {
                                logger.error('trackDsn为空，没有传入埋点上报的dsn地址，请在init中传入');
                                return [2];
                            }
                        }
                        return [4, this.beforePost(data)];
                    case 1:
                        result = _a.sent();
                        if (!result)
                            return [2];
                        if (typeof this.configReportUrl === 'function') {
                            dsn = this.configReportUrl(result, dsn);
                            if (!dsn)
                                return [2];
                        }
                        if (isBrowserEnv) {
                            return [2, this.useImgUpload ? this.imgRequest(result, dsn) : this.xhrPost(result, dsn)];
                        }
                        if (isWxMiniEnv) {
                            return [2, this.wxPost(result, dsn)];
                        }
                        return [2];
                }
            });
        });
    };
    return TransportData;
}());
var transportData = _support.transportData || (_support.transportData = new TransportData());

function log(_a) {
    var _b = _a.message, message = _b === void 0 ? 'emptyMsg' : _b, _c = _a.tag, tag = _c === void 0 ? '' : _c, _d = _a.level, level = _d === void 0 ? Severity.Critical : _d, _e = _a.ex, ex = _e === void 0 ? '' : _e, _f = _a.type, type = _f === void 0 ? ERRORTYPES.LOG_ERROR : _f;
    var errorInfo = {};
    if (isError(ex)) {
        errorInfo = extractErrorStack(ex, level);
    }
    var error = __assign({ type: type,
        level: level, message: unknownToString(message), name: 'MITO.log', customTag: unknownToString(tag), time: getTimestamp(), url: isWxMiniEnv ? getCurrentRoute() : getLocationHref() }, errorInfo);
    breadcrumb.push({
        type: BREADCRUMBTYPES.CUSTOMER,
        category: breadcrumb.getCategory(BREADCRUMBTYPES.CUSTOMER),
        data: message,
        level: Severity.fromString(level.toString())
    });
    transportData.send(error);
}

function httpTransform(data) {
    var message = '';
    var elapsedTime = data.elapsedTime, time = data.time, method = data.method, traceId = data.traceId, type = data.type, status = data.status;
    var name = type + "--" + method;
    if (status === 0) {
        message =
            elapsedTime <= globalVar.crossOriginThreshold ? 'http请求失败，失败原因：跨域限制或域名不存在' : 'http请求失败，失败原因：超时';
    }
    else {
        message = fromHttpStatus(status);
    }
    message = message === SpanStatus.Ok ? message : message + " " + getRealPath(data.url);
    return {
        type: ERRORTYPES.FETCH_ERROR,
        url: getLocationHref(),
        time: time,
        elapsedTime: elapsedTime,
        level: Severity.Low,
        message: message,
        name: name,
        request: {
            httpType: type,
            traceId: traceId,
            method: method,
            url: data.url,
            data: data.reqData || ''
        },
        response: {
            status: status,
            data: data.responseText
        }
    };
}
var resourceMap = {
    img: '图片',
    script: 'js脚本'
};
function resourceTransform(target) {
    return {
        type: ERRORTYPES.RESOURCE_ERROR,
        url: getLocationHref(),
        message: '资源地址: ' + (interceptStr(target.src, 120) || interceptStr(target.href, 120)),
        level: Severity.Low,
        time: getTimestamp(),
        name: (resourceMap[target.localName] || target.localName) + "\u52A0\u8F7D\u5931\u8D25"
    };
}
function handleConsole(data) {
    if (globalVar.isLogAddBreadcrumb) {
        breadcrumb.push({
            type: BREADCRUMBTYPES.CONSOLE,
            category: breadcrumb.getCategory(BREADCRUMBTYPES.CONSOLE),
            data: data,
            level: Severity.fromString(data.level)
        });
    }
}

var handlers = {};
function subscribeEvent(handler) {
    if (!handler || getFlag(handler.type))
        return false;
    setFlag(handler.type, true);
    handlers[handler.type] = handlers[handler.type] || [];
    handlers[handler.type].push(handler.callback);
    return true;
}
function triggerHandlers(type, data) {
    if (!type || !handlers[type])
        return;
    handlers[type].forEach(function (callback) {
        nativeTryCatch(function () {
            callback(data);
        }, function (e) {
            logger.error("\u91CD\u5199\u4E8B\u4EF6triggerHandlers\u7684\u56DE\u8C03\u51FD\u6570\u53D1\u751F\u9519\u8BEF\nType:" + type + "\nName: " + getFunctionName(callback) + "\nError: " + e);
        });
    });
}

export { Breadcrumb, Options, TransportData, breadcrumb, createErrorId, getFlutterRealOrigin, getFlutterRealPath, getRealPageOrigin, getRealPath, handleConsole, hashCode, httpTransform, initOptions, log, options, removeHashPath, resourceTransform, setTraceId, subscribeEvent, transportData, triggerHandlers };
/* follow me on Github! @cjinhuo */
//# sourceMappingURL=core.esm.js.map
